//define a function
function hamburger__click() {
  if ($(".jsHamburger").length > 0) {
    $("header .jsHamburger").on("click", function (e) {
      e.preventDefault();
      $("body").toggleClass("is-menu-visible");
    });
    $(document).click(function (e) {
      var container = $("header");
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        container.parents("body").removeClass("is-menu-visible");
      }
    });
  }
}

//Image to SVG
function imgToSvg() {
  let convertImages = (query, callback) => {
    let images = document.querySelectorAll("img.svg");
    images.forEach((image) => {
      fetch(image.src)
        .then((res) => res.text())
        .then((data) => {
          let parser = new DOMParser();
          let svg = parser
            .parseFromString(data, "image/svg+xml")
            .querySelector("svg");
          svg.setAttribute(
            "viewBox",
            "0 0 " +
            svg.getAttribute("width") +
            " " +
            svg.getAttribute("height"),
          );
          if (image.id) svg.id = image.id;
          if (image.className) svg.classList = image.classList;
          image.parentNode.replaceChild(svg, image);
        })
        .then(callback);
    });
  };
  convertImages("img");
}

// Header sticky on scroll
let lastScrollTop = 0;
const headerSticky = () => {
  if ($(".header").length > 0) {
    let scrollTop = $(window).scrollTop();
    const header = $(".header");

    if (scrollTop > 10) {
      header.addClass("is-sticky");
    } else {
      header.removeClass("is-sticky");
    }
    lastScrollTop = scrollTop;
  }
};


function current__year() {
  if ($("#year").length > 0) {
    var date = new Date();
    var year = date.getFullYear();
    document.getElementById("year").innerHTML = year;
  }
}

//Cursor
function cursorClick() {
  $("a").each(function () {
    let href = $(this).attr("href");
    if (!href || href === "#" || href === "#0" || href === "#!") {
      $(this).addClass("is-unclickable");
    }
  });
}

function searchBtn() {
  if ($("#searchBtn").length > 0) {
    $("#searchBtn").on("click", function (e) {
      e.preventDefault();
      const searchWrap = $(this).parent();
      
      // Toggle expanded state
      if (searchWrap.hasClass("is-expanded")) {
        // Collapse search
        searchWrap.removeClass("is-expanded");
        $(this).show();
        $(".header__search-form").hide();
        $("#searchCloseBtn").hide();
        $("#searchInputExpanded").val(""); // Clear input value
        if ($(window).width() > 768) {
          $(".header__login-wrap").show(); // Show login wrap when search is closed (desktop only)
        }
      } else {
        // Expand search - close login dropdown if open (desktop only)
        if ($(window).width() > 768) {
          $(".header__login-wrap").removeClass("is-open");
          $(".header__login-dropdown").hide();
          $(".header__login-arrow").removeClass("is-rotated");
          $(".header__login-wrap").hide(); // Hide login wrap when search is opened (desktop only)
        }
        
        searchWrap.addClass("is-expanded");
        $(this).hide();
        $(".header__search-form").show();
        $("#searchCloseBtn").show();
        
        // Focus the input field after a short delay to ensure it's visible
        setTimeout(() => {
          $("#searchInputExpanded").focus();
        }, 100);
      }
    });
  }

  // Close button functionality
  if ($("#searchCloseBtn").length > 0) {
    $("#searchCloseBtn").on("click", function (e) {
      e.preventDefault();
      const searchWrap = $(".header__search-wrap");
      
      // Collapse search - return to original state
      searchWrap.removeClass("is-expanded");
      $("#searchBtn").show();
      $(".header__search-form").hide();
      $("#searchInputExpanded").val(""); // Clear input value
      $("#searchCloseBtn").hide();
      if ($(window).width() > 768) {
        $(".header__login-wrap").show(); // Show login wrap when search is closed (desktop only)
      }
    });
  }

  // Mobile search functionality
  if ($("#searchMobileBtn").length > 0) {
    const $mobileSearchBtn = $("#searchMobileBtn");
    const $mobileSearchForm = $(".header__search-mobile form");
    const $mobileSearchInput = $mobileSearchForm.find("input");
    const $mobileSearchClose = $("#searchMobileCloseBtn");

    // Toggle mobile search form
    $mobileSearchBtn.on("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      
      if ($mobileSearchForm.is(":visible")) {
        closeMobileSearch();
      } else {
        openMobileSearch();
      }
    });

    // Close mobile search form
    $mobileSearchClose.on("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      closeMobileSearch();
    });

    // Close mobile search when clicking outside
    $(document).on("click", function (e) {
      if ($mobileSearchForm.is(":visible") && 
          !$mobileSearchForm.is(e.target) && 
          $mobileSearchForm.has(e.target).length === 0 &&
          !$mobileSearchBtn.is(e.target)) {
        closeMobileSearch();
      }
    });

    // Close mobile search with Escape key
    $(document).on("keydown", function (e) {
      if (e.key === "Escape" && $mobileSearchForm.is(":visible")) {
        closeMobileSearch();
      }
    });

    // Helper functions
    function openMobileSearch() {
      $mobileSearchForm.fadeIn(200);
      setTimeout(() => {
        $mobileSearchInput.focus();
      }, 250);
    }

    function closeMobileSearch() {
      $mobileSearchForm.fadeOut(200);
      $mobileSearchInput.val("").blur();
    }
  }

  // Close search when clicking outside
  $(document).on("click", function (e) {
    const searchWrap = $(".header__search-wrap");
    if (searchWrap.hasClass("is-expanded") && 
        !searchWrap.is(e.target) && 
        searchWrap.has(e.target).length === 0) {
      searchWrap.removeClass("is-expanded");
      $("#searchBtn").show();
      $(".header__search-form").hide();
      $("#searchInputExpanded").val(""); // Clear input value
      $("#searchCloseBtn").hide();
      if ($(window).width() > 768) {
        $(".header__login-wrap").show(); // Show login wrap when search is closed (desktop only)
      }
    }
  });

  // Close search with Escape key
  $(document).on("keydown", function (e) {
    if (e.key === "Escape" && $(".header__search-wrap").hasClass("is-expanded")) {
      $(".header__search-wrap").removeClass("is-expanded");
      $("#searchBtn").show();
      $(".header__search-form").hide();
      $("#searchInputExpanded").val(""); // Clear input value
      $("#searchCloseBtn").hide();
      if ($(window).width() > 768) {
        $(".header__login-wrap").show(); // Show login wrap when search is closed (desktop only)
      }
    }
  });
}


const checkbox = document.querySelector('.header__hamburger-checkbox');

checkbox.addEventListener('change', function () {
  if (this.checked) {
    document.body.style.overflow = 'hidden';
  } else {
    document.body.style.overflow = '';
  }
});

function cardSlider() {
  var slideCount = $('.js-card-slider').children().length;
  if ($('.js-card-slider').length > 0) {
  $('.js-card-slider').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: true,
    dots: slideCount > 3,
    autoplay: false,
    autoplaySpeed: 1000,
    prevArrow: '<button type="button" class="slick-prev slick-nav-btn"><i class="arrow-left"></i></button>',
    nextArrow: '<button type="button" class="slick-next slick-nav-btn"><i class="arrow-right"></i></button>',
          responsive: [{
        breakpoint: 1200,
        settings: {
          slidesToShow: 5,
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
          centerMode: true,
          dots: false
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          centerMode: true,
          dots: false
        }
      },
      {
        breakpoint: 550,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          dots: false
        }
      }
    ]
  });
  }
}

function articleSlider() {
  var slideCount = $('.js-article-slider').children().length;
  if ($('.js-article-slider').length > 0) {
    $('.js-article-slider').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: true,
      dots: slideCount > 3,
      autoplay: false,
      autoplaySpeed: 1000,
      prevArrow: '<button type="button" class="slick-prev slick-nav-btn"><i class="arrow-left"></i></button>',
      nextArrow: '<button type="button" class="slick-next slick-nav-btn"><i class="arrow-right"></i></button>',
      responsive: [{
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 550,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
    });
  }
}

function logoSlider() {
  var slideCount = $('.js-logo-slider').children().length;
  if ($('.js-logo-slider').length > 0) {
    $('.js-logo-slider').slick({
      slidesToShow: 6,
      slidesToScroll: 1,
      arrows: true,
      dots: slideCount > 3,
      autoplay: true,
      autoplaySpeed: 1000,
      prevArrow: '<button type="button" class="slick-prev slick-nav-btn"><i class="arrow-left"></i></button>',
      nextArrow: '<button type="button" class="slick-next slick-nav-btn"><i class="arrow-right"></i></button>',
      responsive: [{
        breakpoint: 1200,
        settings: {
          slidesToShow: 5,
          arrows:  true,
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 4,
          arrows:  false,
          dots: false
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 4,
          arrows: false,
          dots: false
        }
      },
      {
        breakpoint: 550,
        settings: {
          slidesToShow: 2,
          arrows:  false,
          dots: false
        }
      }
    ]
    });
  }
}

function articleGridSlider() {
   var slideCount = $('.js-article-grid-slider').children().length;
   if ($('.js-article-grid-slider').length > 0) {
     $('.js-article-grid-slider').slick({
       slidesToShow: 3,
       slidesToScroll: 1,
       arrows: true,
       dots: slideCount > 3,
       autoplay: false,
       autoplaySpeed: 1000,
       prevArrow: '<button type="button" class="slick-prev slick-nav-btn"><i class="arrow-left"></i></button>',
       nextArrow: '<button type="button" class="slick-next slick-nav-btn"><i class="arrow-right"></i></button>',
       responsive: [{
         breakpoint: 1200,
         settings: {
           slidesToShow: 3,
         }
       },
       {
         breakpoint: 991,
         settings: {
           slidesToShow: 3,
         }
       },
       {
         breakpoint: 768,
         settings: {
           slidesToShow: 2,
         }
       },
       {
         breakpoint: 550,
         settings: {
           slidesToShow: 1,
         }
       }
     ]
     });
   }
}
function brandInfoVideoPopup() {
  const videoBlocks = document.querySelectorAll('.video-grid__left');
  if (!videoBlocks || videoBlocks.length === 0) {
    return;
  }

  videoBlocks.forEach(function(videoBlock) {
    const figureElement = videoBlock.querySelector('figure');
    const dialogElement = videoBlock.querySelector('dialog');
    const iframeElement = dialogElement ? dialogElement.querySelector('iframe') : null;
    const videoElement = dialogElement ? dialogElement.querySelector('video') : null;
    const closeButton = dialogElement ? dialogElement.querySelector('.jsVideoClose') : null;

    if (!figureElement || !dialogElement) {
      return;
    }

    const originalSrc = iframeElement ? iframeElement.getAttribute('src') : null;

    const computeAutoplaySrc = (src) => {
      if (!src) return null;
      try {
        const url = new URL(src, window.location.href);
        url.searchParams.set('autoplay', '1');
        //url.searchParams.set('mute', '1'); // improves autoplay reliability
        return url.toString();
      } catch (e) {
        const cleaned = src.replace(/([?&])autoplay=\d+/i, '$1autoplay=1');
        if (/autoplay=\d+/i.test(src)) return cleaned;
        const sep = src.indexOf('?') !== -1 ? '&' : '?';
        return src + sep + 'autoplay=1&mute=1';
      }
    };
    const autoplaySrc = originalSrc ? computeAutoplaySrc(originalSrc) : null;


    function openDialog(event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      if (typeof dialogElement.showModal === 'function') {
        dialogElement.showModal();
      } else {
        dialogElement.setAttribute('open', '');
      }
      const scrollY = window.scrollY;
      document.body.style.top = `-${scrollY}px`;
      document.body.classList.add('is-modal-visible');
      // Auto-play video if it exists (muted for browser autoplay policies)
      if (videoElement) {
        videoElement.muted = true; // Ensure muted for autoplay
        videoElement.play().catch(function(error) {
          console.log('Video autoplay prevented:', error);
        });
      }
      return false;
    }

    function closeDialog() {
      dialogElement.close();
    }

    function handleBackdropClick(event) {
      const rect = dialogElement.getBoundingClientRect();
      const clickedInside = (
        event.clientX >= rect.left &&
        event.clientX <= rect.right &&
        event.clientY >= rect.top &&
        event.clientY <= rect.bottom
      );
      if (!clickedInside) {
        closeDialog();
      }
    }

    function handleClose() {
      const scrollY = document.body.style.top;
      const scrollPosition = parseInt(scrollY || '0') * -1;
      const html = document.documentElement;
      const originalScrollBehavior = html.style.scrollBehavior;
      html.style.scrollBehavior = 'auto';
      document.body.classList.remove('is-modal-visible');
      document.body.style.top = '';
      if (scrollY) {
        window.scrollTo(0, scrollPosition);
      }
      setTimeout(function() {
        html.style.scrollBehavior = originalScrollBehavior;
      }, 0);
      // Pause video if it exists
      if (videoElement) {
        videoElement.pause();
        videoElement.currentTime = 0;
      }
    }
    dialogElement.addEventListener('close', handleClose);


    figureElement.addEventListener('click', openDialog);

    dialogElement.addEventListener('click', handleBackdropClick);

    dialogElement.addEventListener('close', handleClose);

    if (closeButton) {
      closeButton.addEventListener('click', function(e) {
        e.preventDefault();
        closeDialog();
      });
    }
  });
}

// Navigation dropdown functionality
function navigationDropdowns() {
  if ($(".header__nav-item").length > 0) {
    // Handle dropdown toggle on hover and click
    $(".header__nav-item").each(function() {
      const $navItem = $(this);
      const $dropdown = $navItem.find(".header__dropdown");
      const $navLink = $navItem.find(".header__nav-link");
      const $arrow = $navItem.find(".header__nav-arrow");
      
      // Only add functionality if dropdown exists
      if ($dropdown.length > 0) {
        // Desktop hover functionality with timeout to prevent flickering
        let hoverTimeout;
        
        $navItem.on("mouseenter", function() {
          if ($(window).width() > 768) { // Desktop breakpoint
            clearTimeout(hoverTimeout);
            $navItem.addClass("is-open");
            $dropdown.show();
            $arrow.addClass("is-rotated");
          }
        });
        
        $navItem.on("mouseleave", function() {
          if ($(window).width() > 768) { // Desktop breakpoint
            hoverTimeout = setTimeout(function() {
              $navItem.removeClass("is-open");
              $dropdown.hide();
              $arrow.removeClass("is-rotated");
            }, 100); // Small delay to allow mouse to move to dropdown
          }
        });
        
        // Keep dropdown open when hovering over dropdown content
        $dropdown.on("mouseenter", function() {
          if ($(window).width() > 768) { // Desktop breakpoint
            clearTimeout(hoverTimeout);
            $navItem.addClass("is-open");
            $dropdown.show();
            $arrow.addClass("is-rotated");
          }
        });
        
        
        // Mobile/tablet click functionality
        $navLink.on("click", function(e) {
          if ($(window).width() <= 768) { // Mobile/tablet breakpoint
            e.preventDefault();
            
            // Close other open dropdowns
            $(".header__nav-item").not($navItem).removeClass("is-open");
            $(".header__dropdown").not($dropdown).hide();
            $(".header__nav-arrow").not($arrow).removeClass("is-rotated");
            
            // Toggle current dropdown
            $navItem.toggleClass("is-open");
            if ($navItem.hasClass("is-open")) {
              $dropdown.show();
              $arrow.addClass("is-rotated");
            } else {
              $dropdown.hide();
              $arrow.removeClass("is-rotated");
            }
          }
        });
      }
    });
    
    // Close dropdowns when clicking outside
    $(document).on("click", function(e) {
      if (!$(e.target).closest(".header__nav-item").length && 
          !$(e.target).closest(".header__dropdown").length) {
        $(".header__nav-item").removeClass("is-open");
        $(".header__dropdown").hide();
        $(".header__nav-arrow").removeClass("is-rotated");
      }
    });
    
    // Close dropdowns on window resize
    $(window).on("resize", function() {
      $(".header__nav-item").removeClass("is-open");
      $(".header__dropdown").hide();
      $(".header__nav-arrow").removeClass("is-rotated");
    });
  }
}


// Login dropdown functionality
function loginDropdown() {
  if ($(".header__login-wrap").length > 0) {
    const $loginWrap = $(".header__login-wrap");
    const $dropdown = $loginWrap.find(".header__login-dropdown");
    const $loginLink = $loginWrap.find(".header__login");
    const $arrow = $loginWrap.find(".header__login-arrow");
    
    // Desktop hover functionality with timeout to prevent flickering
    let loginHoverTimeout;
    
    $loginWrap.on("mouseenter", function() {
      if ($(window).width() > 768) { // Desktop breakpoint
        clearTimeout(loginHoverTimeout);
        $loginWrap.addClass("is-open");
        $dropdown.show();
        $arrow.addClass("is-rotated");
      }
    });
    
    $loginWrap.on("mouseleave", function() {
      if ($(window).width() > 768) { // Desktop breakpoint
        loginHoverTimeout = setTimeout(function() {
          $loginWrap.removeClass("is-open");
          $dropdown.hide();
          $arrow.removeClass("is-rotated");
        }, 100); // Small delay to allow mouse to move to dropdown
      }
    });
    
    // Keep login dropdown open when hovering over dropdown content
    $dropdown.on("mouseenter", function() {
      if ($(window).width() > 768) { // Desktop breakpoint
        clearTimeout(loginHoverTimeout);
        $loginWrap.addClass("is-open");
        $dropdown.show();
        $arrow.addClass("is-rotated");
      }
    });
    
    $dropdown.on("mouseleave", function() {
      if ($(window).width() > 768) { // Desktop breakpoint
        loginHoverTimeout = setTimeout(function() {
          $loginWrap.removeClass("is-open");
          $dropdown.hide();
          $arrow.removeClass("is-rotated");
        }, 100); // Small delay to allow mouse to move back to login wrap
      }
    });
    
    // Mobile/tablet click functionality
    $loginLink.on("click", function(e) {
      if ($(window).width() <= 768) { // Mobile/tablet breakpoint
        e.preventDefault();
        
        // Close other open dropdowns
        $(".header__nav-item").removeClass("is-open");
        $(".header__dropdown").hide();
        $(".header__nav-arrow").removeClass("is-rotated");
        
        // Toggle current dropdown
        $loginWrap.toggleClass("is-open");
        if ($loginWrap.hasClass("is-open")) {
          $dropdown.show();
          $arrow.addClass("is-rotated");
        } else {
          $dropdown.hide();
          $arrow.removeClass("is-rotated");
        }
      }
    });
    
    // Close login dropdown when clicking outside
    $(document).on("click", function(e) {
      if (!$(e.target).closest(".header__login-wrap").length && 
          !$(e.target).closest(".header__login-dropdown").length) {
        $loginWrap.removeClass("is-open");
        $dropdown.hide();
        $arrow.removeClass("is-rotated");
      }
    });
    
    // Close login dropdown on window resize
    $(window).on("resize", function() {
      $loginWrap.removeClass("is-open");
      $dropdown.hide();
      $arrow.removeClass("is-rotated");
    });
  }
}

$(window).on("load", function () {
  brandInfoVideoPopup();
  imgToSvg();
  current__year();
  cardSlider();
  articleSlider();
  logoSlider();
  articleGridSlider();
  cursorClick();
  searchBtn();
  navigationDropdowns();
  loginDropdown();
});
